import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';

export interface SegmentedToggleOption<T extends string> {
  value: T;
  labelKey: string;
}

@Component({
  selector: 'app-segmented-toggle',
  templateUrl: './segmented-toggle.component.html',
  styleUrls: ['./segmented-toggle.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonToggleModule, TranslateModule],
})
export class SegmentedToggleComponent<T extends string> {
  readonly options = input.required<readonly SegmentedToggleOption<T>[]>();
  readonly value = model.required<T>();
  readonly ariaLabel = input('');
}
